import React from 'react';
import {Navbar, Nav, NavItem} from 'react-bootstrap';
import About from "../About/About.jsx";
import Gallery from "../Gallery/Gallery.jsx";
import Contact from "../Contact/Contact.jsx";
import Location from "../Location/Location.jsx";

const internals = {};

internals.style = {
  width: '100%',
  height: 'auto',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: 'rgba(250,250,255,0.8)'
};


class Container extends React.Component {
  render() {
    return (<div style={internals.style}>
      <About/>
      <Location/>
      <Gallery/>
      {/* <Contact/> */}
    </div>);
  }
}



export default Container;



// WEBPACK FOOTER //
// ./src/Container/Container.jsx